import { Col, Row, Statistic } from 'antd'
import type { ThemeUsageStats as Stats } from './types'

// 主题使用统计（详情弹窗和详情页共用）
export function ThemeUsageStats({ stats }: Readonly<{ stats: Stats | undefined }>) {
  return (
    <Row gutter={16}>
      <Col span={6}>
        <Statistic title="用户实例" value={stats?.total_instances ?? 0} />
      </Col>
      <Col span={6}>
        <Statistic title="活跃实例" value={stats?.active_instances ?? 0} />
      </Col>
      <Col span={6}>
        <Statistic title="总篇章数" value={stats?.total_episodes ?? 0} />
      </Col>
      <Col span={6}>
        <Statistic title="平均篇章" value={stats?.avg_episodes_per_instance ?? 0} precision={1} suffix="篇/用户" />
      </Col>
    </Row>
  )
}
